import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';

export default grapesjs.plugins.add('gjs-child-data-list', (editor, opts) => {
  let options = opts || {};

  let defaults = {
    pfx: 'child-data-list',
    blocks: ['child-data-list'],
    defaultStyle: true,
    labelTable: 'Child Data List',
    labelCMSCategory: 'CMS',
    labelFieldName: 'Collection Fields',
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }
  loadComponents(editor, options);
  loadBlocks(editor, options);
});
